import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { SEOHead } from '../../components/feature/SEOHead';

export default function HorairesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || '';
  
  const pageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Horaires d'Ouverture - EHT AUTOMOBILE Le Creusot",
    "description": "Consultez les horaires d'ouverture d'EHT AUTOMOBILE au Creusot. Ouvert du lundi au dimanche pour tous vos besoins en réparation et entretien automobile.",
    "url": `${siteUrl}/horaires`,
    "mainEntity": {
      "@type": "AutomotiveBusiness",
      "name": "EHT AUTOMOBILE",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Rue des Acacias",
        "addressLocality": "Le Creusot",
        "postalCode": "71200",
        "addressCountry": "FR"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
          "opens": "09:00",
          "closes": "12:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
          "opens": "14:00",
          "closes": "19:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Friday",
          "opens": "09:00",
          "closes": "12:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Friday",
          "opens": "14:00",
          "closes": "19:30"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Saturday",
          "opens": "11:00",
          "closes": "20:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": "Sunday",
          "opens": "11:00",
          "closes": "18:00"
        }
      ]
    }
  };

  const horaires = [
    { jour: 'Lundi', heures: '9h–12h30 / \n14h–19h30', icon: 'ri-calendar-line' },
    { jour: 'Mardi', heures: '9h–12h30 / \n14h–19h30', icon: 'ri-calendar-line' },
    { jour: 'Mercredi', heures: '9h–12h30 / \n14h–19h30', icon: 'ri-calendar-line' },
    { jour: 'Jeudi', heures: '9h–12h30 / \n14h–19h30', icon: 'ri-calendar-line' },
    { jour: 'Vendredi', heures: '9h–12h / \n14h–19h30', icon: 'ri-calendar-line' },
    { jour: 'Samedi', heures: '11h–20h', icon: 'ri-calendar-line', highlight: true },
    { jour: 'Dimanche', heures: '11h–18h', icon: 'ri-calendar-line', highlight: true },
  ];

  return (
    <>
      <SEOHead
        title="Horaires Garage Le Creusot EHT AUTOMOBILE - Ouverture et Contact"
        description="Consultez les horaires d'ouverture du garage EHT AUTOMOBILE au Creusot en Saône-et-Loire. Ouvert du lundi au vendredi de 8h à 12h et de 14h à 18h, samedi de 9h à 12h. Contactez-nous pour réparation automobile, entretien voiture et tous services mécaniques au Creusot."
        keywords="horaires garage Le Creusot, ouverture garage automobile Le Creusot, contact garage Saône-et-Loire, horaire mécanique Le Creusot, garage ouvert samedi"
        canonical="https://ehtautomobile.fr/horaires"
        schema={{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "EHT AUTOMOBILE",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Rue des Acacias",
            "addressLocality": "Le Creusot",
            "postalCode": "71200",
            "addressRegion": "Saône-et-Loire",
            "addressCountry": "FR"
          },
          "telephone": "+33385555555",
          "url": "https://ehtautomobile.fr",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "12:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "14:00",
              "closes": "18:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "09:00",
              "closes": "12:00"
            }
          ]
        }}
      />
      <div className="min-h-screen bg-white font-sans">
        <Navbar />

        <div className="pt-20 sm:pt-24 pb-12 sm:pb-16 px-4 sm:px-6">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-8 sm:mb-12">
              <h1 className="text-4xl sm:text-6xl font-bold text-dark mb-3 sm:mb-4">
                Horaires &amp; <span className="text-secondary">Accès</span>
              </h1>
              <p className="text-base sm:text-xl text-gray-600">
                Votre garage automobile au Creusot, ouvert 7 jours sur 7
              </p>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl sm:rounded-3xl shadow-2xl p-6 sm:p-10 mb-8">
              <div className="flex items-center gap-3 mb-6 sm:mb-8">
                <div className="w-12 h-12 sm:w-16 sm:h-16 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-secondary text-2xl sm:text-4xl"></i>
                </div>
                <div>
                  <h2 className="text-2xl sm:text-4xl font-bold text-dark">Nos Horaires</h2>
                  <p className="text-sm sm:text-base text-gray-600">Ouvert toute la semaine</p>
                </div>
              </div>

              <div className="space-y-3 sm:space-y-4">
                {horaires.map((item) => (
                  <div
                    key={item.jour}
                    className={`flex items-center justify-between p-4 sm:p-6 rounded-xl transition-all ${
                      item.highlight
                        ? 'bg-secondary/5 border-2 border-secondary/20'
                        : 'bg-white border border-gray-200'
                    }`}
                  >
                    <div className="flex items-center gap-3 sm:gap-4">
                      <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
                        item.highlight ? 'bg-secondary/20' : 'bg-gray-100'
                      }`}>
                        <i className={`${item.icon} text-lg sm:text-xl ${
                          item.highlight ? 'text-secondary' : 'text-gray-600'
                        }`}></i>
                      </div>
                      <p className={`text-base sm:text-xl font-bold ${
                        item.highlight ? 'text-secondary' : 'text-dark'
                      }`}>
                        {item.jour}
                      </p>
                    </div>
                    <p className="text-sm sm:text-lg font-semibold text-gray-700 whitespace-pre-line">
                      {item.heures}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-6 sm:mt-8 p-4 sm:p-6 bg-green-50 border-2 border-green-200 rounded-xl">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <div>
                    <p className="text-base sm:text-lg font-bold text-green-900 mb-1">
                      Ouvert 7 jours sur 7
                    </p>
                    <p className="text-sm sm:text-base text-green-800">
                      Nous sommes à votre service toute la semaine, y compris le week-end
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8 mb-8">
              <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 border border-gray-100">
                <div className="flex items-center gap-3 mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-secondary text-2xl sm:text-3xl"></i>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-dark">Notre Adresse</h3>
                </div>
                <p className="text-base sm:text-lg text-gray-700 mb-4 leading-relaxed">
                  <strong>EHT AUTOMOBILE</strong><br />
                  Rue des Acacias<br />
                  71200 Le Creusot
                </p>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=EHT+AUTOMOBILE+Rue+des+Acacias+71200+Le+Creusot"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-secondary font-semibold hover:underline cursor-pointer text-sm sm:text-base"
                >
                  <i className="ri-map-2-line text-lg"></i>
                  Voir sur Google Maps
                </a>
              </div>

              <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 border border-gray-100">
                <div className="flex items-center gap-3 mb-4 sm:mb-6">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 bg-secondary/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-secondary text-2xl sm:text-3xl"></i>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-dark">Nous Contacter</h3>
                </div>
                <p className="text-sm sm:text-base text-gray-600 mb-4">
                  Une question ? Besoin d'un renseignement ?<br />
                  Appelez-nous directement
                </p>
                <a
                  href="tel:+33661515174"
                  className="inline-flex items-center gap-3 bg-secondary/10 px-5 py-3 rounded-xl hover:bg-secondary/20 transition-all cursor-pointer"
                >
                  <div className="w-10 h-10 bg-secondary rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-white text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-600">Appelez-nous</p>
                    <p className="text-lg sm:text-xl font-bold text-dark">06 61 51 51 74</p>
                  </div>
                </a>
              </div>
            </div>

            <div className="bg-gradient-to-r from-dark to-gray-800 rounded-2xl sm:rounded-3xl shadow-2xl p-6 sm:p-10 text-center">
              <h3 className="text-2xl sm:text-4xl font-bold text-white mb-3 sm:mb-4">
                Prêt à prendre rendez-vous ?
              </h3>
              <p className="text-base sm:text-lg text-gray-300 mb-6 sm:mb-8">
                Réservez votre créneau en ligne ou contactez-nous directement
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
                <Link
                  to="/rendez-vous"
                  className="bg-secondary text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-semibold hover:bg-blue-600 transition-all hover:shadow-2xl inline-flex items-center justify-center gap-2 sm:gap-3 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-calendar-check-line text-lg sm:text-xl"></i>
                  PRENDRE RENDEZ-VOUS
                </Link>
                <a
                  href="tel:+33661515174"
                  className="bg-white text-dark px-6 sm:px-10 py-4 sm:py-5 rounded-full text-base sm:text-lg font-semibold hover:bg-gray-100 transition-all hover:shadow-2xl inline-flex items-center justify-center gap-2 sm:gap-3 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-lg sm:text-xl"></i>
                  APPELER LE GARAGE
                </a>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
}
